// Tipos + regras client-side da edição da análise de jornada (C2).
// A validação de ANALISADO é client-side (backend é leniente — C1 Opção 1).
// derivarClassificacao é só PREVIEW; a verdade é derivada no backend.

export interface FormRecomendacao {
  step: string;
  recommendationId: number | null;
  comentarios: string;
  weeklyWorkHours: number | null;
  workScheduleTypeCode: number | null;
  partTimeContractCode: number | null;
  nightShift: boolean | null;
  workScheduleRegTypeCode: number | null;
}

export function derivarClassificacao(step: string, risco: string | null): string {
  if (step === 'PENDENTE_DE_ESCLARECIMENTO') return 'PENDENTE_DE_ESCLARECIMENTO';
  if (step === 'ANALISADO') return risco === 'INEXPRESSIVO' ? 'INEXPRESSIVO' : 'RISCO_DETECTADO';
  return 'EM_ANALISE';
}

export function camposObrigatoriosAnalisado(f: FormRecomendacao): string[] {
  if (f.step !== 'ANALISADO') return [];
  const faltas: string[] = [];
  if (f.recommendationId == null) faltas.push('Ocorrência');
  if (f.workScheduleRegTypeCode == null) faltas.push('Regime de jornada');
  if (f.workScheduleTypeCode == null) faltas.push('Tipo de jornada');
  if (f.partTimeContractCode == null) faltas.push('Tempo parcial');
  if (f.weeklyWorkHours == null) faltas.push('Carga horária semanal');
  if (f.nightShift == null) faltas.push('Horário noturno');
  return faltas;
}

export function toUpdatePayload(f: FormRecomendacao) {
  return {
    step: f.step,
    recommendationId: f.recommendationId,
    comentariosRecomendacoesAdicionais: f.comentarios || null,
    weeklyWorkHours: f.weeklyWorkHours,
    workScheduleTypeCode: f.workScheduleTypeCode,
    partTimeContractCode: f.partTimeContractCode,
    nightShift: f.nightShift,
    workScheduleRegTypeCode: f.workScheduleRegTypeCode,
  };
}
